<template>
	<!--
    DOC

    sotto componenti delle colonne,
    elemento che crea sezione draggabile e geswtisce le cose

    di fatto è simile a builder.vue sulle funzioni


    -->
	<div :key="force_refresh" style="display: flex; flex-direction: column" v-bind:style="styleObjectParent">
		<div v-if="componenti.length <= 1" style="width: 100%" v-bind:style="styleObject">
			<el-tooltip class="item" effect="dark" :content="$t('paste')" placement="top-start">
				<el-button class="_btn" v-if="cut && isEditable" @click="pasteAt(componenti[0], -1)" circle>
					<md-icon>content_paste</md-icon>
				</el-button>
			</el-tooltip>
			<draggable
				:list="componenti[0]"
				class="list-group"
				:options="dragOptionsInside2"
				:empty-insert-threshhold="500"
				handle=".handle"
				:scroll-sensitivity="200"
				:force-fallback="true"
				style="min-height: 100px !important; min-width: 60px; width: 95%; padding: 10px; margin: 10px"
			>
				<el-card
					v-if="element"
					class="box-card"
					v-for="(element, idx) in componenti[0]"
					:style="{ border: element.ref_id !== undefined ? '4px solid #409eff' : 'none' }"
				>
					<div style="width: 100%; height: auto; min-height: 60px">
						<md-icon class="handle" style="float: left">open_with</md-icon>
						<el-badge
							v-if="element.ref_id !== undefined"
							:value="$t('saved-block')"
							class="item"
							type="primary"
						>
							<div style="max-width: 600px; overflow: hidden">{{ element.name }}</div>
						</el-badge>
						<div style="display: inline" v-else>{{ element.name }}</div>
						<el-tooltip
							v-if="element.wiki"
							style="border: none; width: 25px; left: 90px; position: relative"
							class="item"
							effect="dark"
							:content="element.wiki"
							placement="top"
						>
							<md-icon>help_outline</md-icon>
						</el-tooltip>

						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('delete')"
							placement="top-start"
							:open-delay="500"
						>
							<el-button class="_btn" v-if="isEditable" @click="removeAt(idx, 0)" circle>
								<md-icon>delete</md-icon>
							</el-button>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('clone')"
							placement="top-start"
							:open-delay="500"
						>
							<el-button class="_btn" v-if="isEditable" @click="cloneAt(componenti[0], idx)" circle>
								<md-icon>content_copy</md-icon>
							</el-button>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('cut')"
							placement="top-start"
							:open-delay="500"
						>
							<el-button class="_btn" v-if="!cut && isEditable" @click="cutAt(componenti[0], idx)" circle>
								<md-icon>content_cut</md-icon>
							</el-button>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('paste')"
							placement="top-start"
							:open-delay="500"
						>
							<el-button
								class="_btn"
								v-if="cut && isEditable"
								@click="pasteAt(componenti[0], idx)"
								circle
							>
								<md-icon>content_paste</md-icon>
							</el-button>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('save-as-new-block')"
							placement="top-start"
							:open-delay="500"
						>
							<el-button
								class="_btn"
								v-if="isEditable && element.ref_id === undefined"
								@click="saveEl(componenti[0][idx])"
								circle
							>
								<md-icon>save</md-icon>
							</el-button>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('edit-style')"
							placement="top-start"
							:open-delay="500"
						>
							<el-button
								class="_btn"
								v-if="isEditable && element.ref_id === undefined"
								@click="editEl(componenti[0][idx])"
								circle
							>
								<md-icon>edit</md-icon>
							</el-button>
						</el-tooltip>
						<el-tooltip
							class="item"
							effect="dark"
							:content="$t('edit-as-single-blocks')"
							placement="top-start"
							:open-delay="500"
						>
							<el-button
								class="_btn"
								v-if="element.ref_id !== undefined"
								@click="editElAsBlock(element)"
								circle
							>
								<md-icon>post_add</md-icon>
							</el-button>
						</el-tooltip>
					</div>
					<reflect-component
						:isEditable="isEditable && element.ref_id === undefined"
						:key="element.id + 'subcompo'"
						:element="element"
					></reflect-component>
				</el-card>
			</draggable>
		</div>
		<div
			v-else
			style="
				width: 100%;
				height: 80px;
				display: flex;
				align-content: center;
				align-items: center;
				align-self: center;
				justify-content: center;
			"
		>
			<div
				v-for="(el, index) in componenti"
				:style="{ width: 100 / componenti.length + '%' }"
				style="
					height: 80px;
					border: 1px dotted black;
					display: flex;
					align-content: center;
					align-items: center;
					align-self: center;
					justify-content: center;
				"
			>
				<el-button @click="editElement(el)">modifica {{ index }}</el-button>
			</div>
			<lateral-editor
				ref="lateral"
				:key="'super_cool_Editor_' + isEditable"
				:show="opened"
				:elemento="editing_element"
				@changeShow="
					val => {
						this.opened = val
					}
				"
				@updateval="
					val => {
						this.editing_element = val
					}
				"
				:isEditable="isEditable"
			></lateral-editor>
		</div>
	</div>
</template>
<script>
import draggable from "vuedraggable"
import ReflectComponent from "@/modules/builder/Reflect/reflect-component"
import { clone, cloneAt } from "../utils/utils"
import { mapActions, mapGetters } from "vuex"
import LateralEditor from "./lateral-editor"
import { uuid } from "@/modules/builder/utils/utils"
import RawDisplayer from "@/modules/builder/components/raw-displayer"
import axios from "axios"

export default {
	name: "subcomponents",
	watch: {
		editing_element: e => {},
		opened: e => {}
	},
	methods: {
		...mapActions({
			setCut: "builder/setCut",
			resetCut: "builder/resetCut"
		}),
		async cutAt(list, id) {
			await this.setCut(list[id])
			list.splice(id, 1)
			this.$el.focus()
		},
		async pasteAt(list, id) {
			list.splice(id + 1, 0, this.cut)
			await this.resetCut()
			this.$el.focus()
		},
		uuid,
		editElement(el) {
			this.opened = true
			this.editing_element = el
			this.$refs.lateral.$el.focus()
		},
		editElAsBlock(el) {
			/**
			 * DOC
			 * trigger l'edit css dell'elemento come blocco perchè lui è bloccato ma vabbè ok
			 *
			 * */
			this.$confirm(this.$t("warning-edit-shared-block"), "Attenzione", {
				confirmButtonText: "OK",
				cancelButtonText: "Cancel",
				type: "warning"
			})
				.then(() => {
					el.ref_id = undefined
				})
				.catch(() => {})
		},
		...mapActions({
			addElement: "builder/addElement",
			editInsert: "builder/editInsert",
			editEdit: "builder/editEdit",
			showModalInsert: "builder/showModalInsert",
			hideModalInsert: "builder/hideModalInsert",
			hideModalEdit: "builder/hideModalEdit",
			showModalEdit: "builder/showModalEdit"
		}),
		editEl(el) {
			this.editEdit(el)
			this.showModalEdit()
		},
		saveEl(el) {
			var toinsertel = clone(el)
			toinsertel.name += "(salvato)"
			toinsertel.id = Math.random().toString(16).slice(2)
			this.editInsert(toinsertel)
			this.showModalInsert()
		},
		removeAt(idx, index) {
			this.componenti[index].splice(idx, 1)
		},
		updateIfNeeded() {
			if (this.componenti.length <= 0) {
				/**
				 * DOC
				 *
				 * Spiegazione funzione carina
				 *
				 * quando hai l'array dei figli vuoti c'è un problema di render e si rompe tutto.
				 * Perchè l'array è [] così
				 * per funzionare dovrebbe essere  [[],[]] per esempio nel caso di due colonne
				 * per evitare di scriverlo nella dichiarazione, questa funzione si occupa di istanziarlo al create dell'elemento
				 * quindi pusha x array vuoti sull'array parent
				 *
				 * se non è chiaro, all' occorrenza farò un disegnino
				 * */
				this.$emit(
					"updateComp",
					Array(this.children)
						.fill("")
						.map(() => Array())
				)
				// this.componenti=  Array( this.children ).fill( "" ).map( () => Array() )
			}
		},
		cloneAt(a, b) {
			cloneAt(a, b)
		},
		clone(a) {
			return clone(a)
		},
		checkSaved(data = this.componenti[0]) {
			if (data) {
				data.forEach((componente, index, theArray) => {
					if (componente.ref_id) {
						axios
							.get(process.env.VUE_APP_API_URL + "/api/blocks/getSavedBlock/" + componente.ref_id, {
								headers: { Authorization: "Bearer " + localStorage.getItem("JWT") }
							})
							.then(res => {
								res.data.blocks.json.ref_id = res.data.blocks.ref_id
								res.data.blocks.json.deleted = null
								res.data.blocks.json.name = res.data.blocks.name
								res.data.blocks.json.wiki = res.data.blocks.wiki

								if (res.data.blocks.json.items[0].length) {
									this.checkSaved(res.data.blocks.json.items[0])
								}

								theArray[index] = res.data.blocks.json

								this.force_refresh = this.uuid()
								return true
							})
							.catch(err => console.error(err))
					}
				})
			}
		}
	},
	mounted() {
		this.updateIfNeeded()
		this.checkSaved()
	},
	data() {
		return {
			styleObject: {
				"min-height": "100px",
				height: "100%",
				"min-width": "60px",
				border: "1px dotted black",
				width: 90 / this.children + "%",
				display: "inline-block"
			},
			styleObjectParent: {
				"min-height": "100px",
				height: "100%",
				"min-width": "80%",
				border: "none"
			},
			opened: undefined,
			editing_element: undefined,
			force_refresh: uuid()
		}
	},
	components: {
		RawDisplayer,
		LateralEditor,
		draggable,
		ReflectComponent,
		clone,
		cloneAt
	},
	computed: {
		dragOptionsInside2() {
			return {
				group: {
					name: "items2",
					pull: this.isEditable,
					put: this.isEditable,
					move: this.isEditable
				},
				sort: this.isEditable,
				disabled: !this.isEditable,
				ghostClass: "ghost",
				chosenClass: "dragCustomClass",
				animation: 200
			}
		},
		...mapGetters({
			cut: "builder/cut"
		})
	},
	props: {
		children: {
			required: true,
			default: 1
		},
		componenti: {
			required: true,
			type: Array
		},
		isEditable: {
			required: true,
			type: Boolean
		}
	}
}
</script>
<style scoped>
.button {
	margin-top: 35px;
}

.flip-list-move {
	transition: transform 0.5s;
}

.no-move {
	transition: transform 0s;
}

.ghost {
	opacity: 0.5;
	background: #c8ebfb;
}

.list-group {
	min-height: 20px;
}

.list-group-item {
	cursor: move;
}

.list-group-item i {
	cursor: pointer;
}
</style>
